import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cMsgSet from './cMsgSet';

export default class iMsgSet extends cMsgSet {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  render() {
    return ( //  子で上書き
      <ce.RootDtl
        b_logo={false}
        b_sch={true}
        onSchEnt={null}
        b_rhtVsb={true}
        rhtIconName={null}
        rhtPfx={null}
        onRhtPrs={null}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: iv._get_hdrPfx('メッセージグループ情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgc_pageMode),
          d_subMenus: {
            b_vsb: false,
          },
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_ct21c310',
              pfx:'グループ名',
              phd:'省略時はメンバ名を設定',
              b_mln:false,
            },
            {
              type: 'PckSchs',
              b_vsb: true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state: 'sld_itemss',
              pfx: 'メンバ',
            },
            { // 20211003 削除対応
              type:'Pck',
              b_vsb: true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_ct21cz10',
              ini: '10',
              pfx:'削除区分',
              ld_iss: [
                {key:'10', pfx: '削除しない'},
                {key:'0', pfx: '削除する'},
              ],
            },
          ],
        }}
        onPckSchMdlEnt={(_schWord)=>{
//          let _cnd = bf.q('[cm10c310] LIKE "%{}%"'.f(_schWord));
          let _cnd = bf.q('[cm10b21k]="{}" AND [cm10c310] LIKE "%{}%"'.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            _schWord,
          ));
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm10', 
            n_dms: 3, 
            cnd: _cnd,
           })
          .then( _ld_cm10ss => {
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                let _ld_iss = _ld_cm10ss.map( _d_cm10s => {
                  return {
                    key: _d_cm10s._KEY,
                    pfx: _d_cm10s.cm10c310,
                  };
                });
                _next.pckSch.ld_itemss = _ld_iss;
              }),
            }, ()=>{
            });
          });
        }}
      />
    );
  }

};
